import {Inject, Injectable} from '@angular/core';
import {AUTHENTICATION, Authentication} from '@infrastructure/http/authentication/authentication';
import {LocalStorageService} from '@vdw/angular-component-library';
import {Observable, of as observableOf} from 'rxjs';
import {PageStateManager} from '../page-state-manager';
import {ProductionScheduleBuilderPageStateWithUserEmail} from './production-schedule-builder-page-state-with-user-email.interface';
import {ProductionScheduleBuilderPageState} from './production-schedule-builder-page-state.interface';
import {ProductionScheduleNewBuilderPageStateWithUserEmail} from './production-schedule-new-builder-page-state-with-user-email.interface';
import {ProductionScheduleNewBuilderPageState} from './production-schedule-new-builder-page-state.interface';

@Injectable()
export class ProductionScheduleBuilderPageStateManagerService implements PageStateManager<ProductionScheduleBuilderPageState> {
  public static readonly localStorageKeyForProductionScheduleBuilderState = 'productionScheduleBuilderState';
  public static readonly localStorageKeyForProductionScheduleNewBuilderState = 'productionScheduleNewBuilderState';

  public constructor(
    @Inject(AUTHENTICATION) private readonly authentication: Authentication,
    private readonly localStorageService: LocalStorageService
  ) {}

  public get(): Observable<ProductionScheduleBuilderPageState> {
    return observableOf(
      this.getProductionScheduleBuilderPageStates().find(
        (productionScheduleBuilderPageStates: ProductionScheduleBuilderPageStateWithUserEmail) => productionScheduleBuilderPageStates.userEmail === this.authentication.getCurrentEmail()
      )
    );
  }

  public getForNewBuilder(): Observable<ProductionScheduleNewBuilderPageState> {
    return observableOf(
      this.getProductionScheduleNewBuilderPageStates().find(
        (productionScheduleBuilderPageStates: ProductionScheduleNewBuilderPageStateWithUserEmail) => productionScheduleBuilderPageStates.userEmail === this.authentication.getCurrentEmail()
      )
    );
  }

  public update(state: ProductionScheduleBuilderPageState): Observable<void> {
    const userEmail = this.authentication.getCurrentEmail();

    const productionScheduleBuilderPageStates = this.getProductionScheduleBuilderPageStates()?.filter(
      (productionScheduleBuilderPageState: ProductionScheduleBuilderPageStateWithUserEmail) => productionScheduleBuilderPageState.userEmail !== userEmail
    );

    productionScheduleBuilderPageStates.push({userEmail, ...state});

    this.localStorageService.set(ProductionScheduleBuilderPageStateManagerService.localStorageKeyForProductionScheduleBuilderState, productionScheduleBuilderPageStates);

    return observableOf(null);
  }

  public updateforNewBuilder(state: ProductionScheduleNewBuilderPageState): Observable<void> {
    const userEmail = this.authentication.getCurrentEmail();

    const productionScheduleBuilderPageStates = this.getProductionScheduleNewBuilderPageStates()?.filter(
      (productionScheduleBuilderPageState: ProductionScheduleNewBuilderPageStateWithUserEmail) => productionScheduleBuilderPageState.userEmail !== userEmail
    );

    productionScheduleBuilderPageStates.push({userEmail, ...state});

    this.localStorageService.set(ProductionScheduleBuilderPageStateManagerService.localStorageKeyForProductionScheduleNewBuilderState, productionScheduleBuilderPageStates);

    return observableOf(null);
  }

  private getProductionScheduleBuilderPageStates(): ProductionScheduleBuilderPageStateWithUserEmail[] {
    const productionScheduleBuilderPageStatesJSON = this.localStorageService.get<ProductionScheduleBuilderPageStateWithUserEmail[]>(
      ProductionScheduleBuilderPageStateManagerService.localStorageKeyForProductionScheduleBuilderState
    );

    return productionScheduleBuilderPageStatesJSON ?? [];
  }

  private getProductionScheduleNewBuilderPageStates(): ProductionScheduleNewBuilderPageStateWithUserEmail[] {
    const productionScheduleBuilderPageStatesJSON = this.localStorageService.get<ProductionScheduleNewBuilderPageStateWithUserEmail[]>(
      ProductionScheduleBuilderPageStateManagerService.localStorageKeyForProductionScheduleNewBuilderState
    );

    return productionScheduleBuilderPageStatesJSON ?? [];
  }
}
